import "./App.css";
import { Provider } from "react-redux";
import MainLayout from "./modules/common/MainLayout";
import { ThemeProvider, createTheme } from "@mui/material";
import { themeConfig } from "./config/ThemeConfig";
import store from "./store/Store";

const theme = createTheme(themeConfig);

function App() {
  return (
    <>
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <MainLayout />
        </ThemeProvider>
      </Provider>
    </>
  );
}

export default App;
